var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',_vm._g(_vm._b({attrs:{"outlined":"","multiple":"","chips":"","label":this.label,"accept":"text/csv","prepend-icon":"","prepend-inner-icon":"mdi-paperclip"}},'v-file-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }